module.exports = __webpack_public_path__ + "img/smalltreenw.e8dc6ad7.webp";